import { render, staticRenderFns } from "./ErrorOnSite.vue?vue&type=template&id=89c398c2&scoped=true&"
import script from "./ErrorOnSite.vue?vue&type=script&lang=js&"
export * from "./ErrorOnSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c398c2",
  null
  
)

export default component.exports